function Button(props) {
    return (
        <a className={`btn btn-orange p-3 px-5 ${props.class !== undefined ? props.class : ""}`} href={props.href}>{props.children}</a>
    );
}

export default Button;
